export class OrderSummaryModel {
    constructor(
        public SubTotal: number = 0,
        public PromoCode: string = '',
        // public Shipping: string = 'Free',
        public Shipping: number = 0,
        public Taxes: string = 'TBD',
        public Total: number = 0,
        public PromoCodeDiscount: number = 0,
        public PromoCodeAmount: number = 0,
        public TaxAmount: number = 0,
    ) { }
}

export class FinalOrderSummaryModel {
    constructor(
        public BookImage: string = '',
        public BookName: string = '',
        public Quantity: Number = 0,
        public ListPrice: Number = 0,
        public DiscountPrice: Number = 0,
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/core/models/OrderSummary.model.ts